import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import useReducedMotion from '@/hooks/useReducedMotion';

const CATS = [
  {
    label: 'COFFRETS CIRCUITS',
    desc: 'Voir la sélection',
    path: '/shop?cat=coffrets-circuits',
    image: 'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/bcf4f96dd_cat-coffrets-240.jpg',
    bg: 'bg-blue-900',
  },
  {
    label: 'VOITURES',
    desc: 'Voir la sélection',
    path: '/shop?cat=voitures',
    image: 'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/b1c044ee8_cat-voitures-240.jpg',
    bg: 'bg-red-900',
  },
  {
    label: 'ACCESSOIRES',
    desc: 'Voir la sélection',
    path: '/shop?cat=accessoires',
    image: 'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/dc5ab7cf1_cat-accessoires-240.jpg',
    bg: 'bg-gray-800',
  },
  {
    label: 'PIÈCES DÉTACHÉES',
    desc: 'Voir la sélection',
    path: '/shop?cat=pieces-detachees',
    image: 'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/838cab634_cat-pieces-240.jpg',
    bg: 'bg-orange-900',
  },
  {
    label: 'DÉCOR',
    desc: 'Voir la sélection',
    path: '/shop?cat=decor',
    image: 'https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/4a252d926_cat-decor-240.jpg',
    bg: 'bg-green-900',
  },
];

export default function CSCategoryBanners() {
  const prefersReducedMotion = useReducedMotion();
  return (
    <section className="max-w-screen-xl mx-auto px-4 py-10">
      <h2 className="font-display font-bold text-2xl text-gray-900 mb-6">NOS CATÉGORIES</h2>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {CATS.map(cat => (
          <Link key={cat.label} to={cat.path} className="group relative rounded-lg overflow-hidden aspect-[4/3]">
            <img
              src={cat.image}
              alt=""
              width="240"
              height="180"
              loading="lazy"
              decoding="async"
              sizes="(max-width: 768px) 50vw, 20vw"
              className={`w-full h-full object-cover ${!prefersReducedMotion ? 'group-hover:scale-105 transition-transform duration-300' : ''}`}
            />
            <div className={`absolute inset-0 ${cat.bg} opacity-60`} />
            <div className="absolute inset-0 flex flex-col justify-end p-4">
              <p className="font-display font-bold text-white text-sm md:text-base leading-tight">{cat.label}</p>
              <div className="flex items-center gap-1 text-blue-200 text-xs mt-1 group-hover:gap-2 transition-all">
                <span>{cat.desc}</span>
                <ArrowRight className="w-3 h-3" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}